import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(err, info) { console.warn("[ErrorBoundary]", err?.message || err); }
  reset = () => this.setState({ hasError: false });
  render() {
    if (this.state.hasError) {
      return (
        <div className="glass rounded-xl p-6 text-slate-300">
          <div className="text-sm">Something glitched. Try reloading.</div>
          <button onClick={this.reset} className="mt-3 px-3 py-1.5 rounded bg-red-600 text-white text-xs">
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
